import {combineReducers}            from "redux"
import Accounts                from "./Accounts"

const Failed = combineReducers({
  Accounts,
})

export default Failed
